// @ts-nocheck
import React from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";
import { trpcClient } from "@/lib/trpc";
import { QCFinalForm } from "./QCFinalForm";

export default function QCFinalCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const searchParams = useSearch({ strict: false }) as any;

  const productionOrderId = searchParams?.productionOrderId || "";
  const poCode = searchParams?.poCode || "";
  // Cỡ lô: SL chờ kiểm từ hàng chờ (nếu có); không có thì form lấy SL kế hoạch của lệnh SX
  const pendingQty = Number(searchParams?.pendingQty) || Number(searchParams?.qtyPlan) || 0;
  const customerName = searchParams?.customerName || "";

  const initialData = {
    productionOrderId,
    productId: searchParams?.productId || "",
    productTypeId: searchParams?.productTypeId || "",
    customerId: searchParams?.customerId || "",
    orderId: searchParams?.orderId || "",
    qtyChecked: pendingQty || undefined,
    qtyFailed: 0,
    lotNumber: poCode ? `LOT-${poCode}` : "",
    notes: customerName
      ? `Nghiệm thu thành phẩm từ LSX ${poCode} - Khách hàng: ${customerName}`
      : "",
  };

  const handleSubmit = async (data: any) => {
    try {
      const payload = {
        ...data,
        aqlStandard: Number(data.aqlStandard) || 1.5,
      };
      const created = await (trpcClient as any).qcFinal.create.mutate(payload);
      toast.success("Tạo phiếu nghiệm thu thành phẩm (FQC) thành công!");
      await queryClient.invalidateQueries({ queryKey: ["qcFinal"] });
      await queryClient.invalidateQueries({ queryKey: ["qc-final-all"] });
      await queryClient.invalidateQueries({ queryKey: ["pending-fqc-queue"] });
      navigate({
        to: "/qc-final/$checkId",
        params: { checkId: created.id },
        replace: true,
      });
    } catch (err: any) {
      toast.error(err?.message || "Lỗi khi tạo phiếu FQC");
      throw err;
    }
  };

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "Kiểm tra Thành phẩm (FQC)", to: "/qc-final" },
        { label: "Nghiệm thu FQC mới" },
      ]}
      title="Lập Biên Bản FQC"
      onBack={() => navigate({ to: "/qc-final" })}
      actions={
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => navigate({ to: "/qc-final" })}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            size="sm"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold"
            onClick={() => {
              const formEl = document.getElementById(
                "qc-final-canonical-form"
              ) as HTMLFormElement | null;
              formEl?.requestSubmit();
            }}
          >
            <Save className="w-4 h-4 mr-1.5" /> Lưu Biên Bản FQC
          </Button>
        </div>
      }
    >
      <QCFinalForm
        containerMode="embedded"
        initialData={initialData}
        params={{ productionOrderId }}
        onSubmit={handleSubmit}
        onCancel={() => navigate({ to: "/qc-final" })}
      />
    </StandardDetailLayout>
  );
}
